/* tslint:disable */
/* eslint-disable */
/**
 * WAG TP Request API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WAGTPServiceContractProvisioning,
    WAGTPServiceContractProvisioningFromJSON,
    WAGTPServiceContractProvisioningFromJSONTyped,
    WAGTPServiceContractProvisioningToJSON,
} from './';

/**
 * 
 * @export
 * @interface WAGTPServiceContractProvisioningWrap
 */
export interface WAGTPServiceContractProvisioningWrap {
    /**
     * 
     * @type {WAGTPServiceContractProvisioning}
     * @memberof WAGTPServiceContractProvisioningWrap
     */
    serviceContractProvisioning: WAGTPServiceContractProvisioning;
}

export function WAGTPServiceContractProvisioningWrapFromJSON(json: any): WAGTPServiceContractProvisioningWrap {
    return WAGTPServiceContractProvisioningWrapFromJSONTyped(json, false);
}

export function WAGTPServiceContractProvisioningWrapFromJSONTyped(json: any, ignoreDiscriminator: boolean): WAGTPServiceContractProvisioningWrap {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'serviceContractProvisioning': WAGTPServiceContractProvisioningFromJSON(json['serviceContractProvisioning']),
    };
}

export function WAGTPServiceContractProvisioningWrapToJSON(value?: WAGTPServiceContractProvisioningWrap | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'serviceContractProvisioning': WAGTPServiceContractProvisioningToJSON(value.serviceContractProvisioning),
    };
}


